import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import DevisView from '@/views/DevisView.vue'
import TerrassementView from '@/views/TerrassementView.vue'
import ConditionsView from '@/views/ConditionsView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/historique',
    name: 'historique',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/HistoriqueView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ContactView.vue')
  },
  {
    path: '/devis',
    name: 'DevisView',
    component: DevisView,
    props: true // Pour accepter les params de routing comme 'selectedContainer'
  },
  {
    path: '/materiaux',
    name: 'materiaux',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/MateriauxView.vue')
  },
  {
    path: '/conteneurs',
    name: 'conteneurs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ContainersView.vue')
  },
  {
    path: '/terrassements',
    name: 'TerrassementView',
    component: TerrassementView
  },
  {
    path: '/conditions',
    name: 'ConditionsView',
    component: ConditionsView
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
